import React, { useState, useEffect } from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, ReferenceLine } from 'recharts';
import { api } from '../../services/api';
import ReportDateSelector, { DateRangeOption } from './ReportDateSelector';

const NRRTrendChart: React.FC = () => {
  const [range, setRange] = useState<DateRangeOption>('90d');
  const [data, setData] = useState<any[]>([]);

  useEffect(() => {
    let isMounted = true;
    const fetchNrr = async () => {
      try {
        const res = await api.analytics.getNrrTrend(range);
        if (isMounted && Array.isArray(res)) {
          setData(res);
        }
      } catch (err) {
        console.error('Failed to load NRR trend:', err);
      }
    };
    fetchNrr();
    return () => { isMounted = false; };
  }, [range]);

  return (
    <div id="nrr-trend-chart" className="bg-white p-8 rounded-3xl border border-slate-200 shadow-sm">
      <div className="flex justify-between items-start mb-6">
        <div>
          <h2 className="text-xl font-black text-slate-900 mb-1">Net Revenue Retention (NRR)</h2>
          <p className="text-sm text-slate-500">Revenue growth & expansion from existing accounts.</p>
        </div>
        <ReportDateSelector value={range} onChange={setRange} />
      </div>
      <div className="h-[280px]">
        {data.length === 0 ? (
          <div className="h-full flex items-center justify-center text-slate-400 text-sm">Loading NRR metrics...</div>
        ) : (
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={data}>
              <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#f1f5f9" />
              <XAxis dataKey="month" axisLine={false} tickLine={false} tick={{fontSize: 12, fill: '#64748b'}} />
              <YAxis domain={[90, 130]} axisLine={false} tickLine={false} tick={{fontSize: 11, fill: '#64748b'}} tickFormatter={(v) => `${v}%`} />
              <Tooltip 
                contentStyle={{ borderRadius: '16px', border: '1px solid #e2e8f0', boxShadow: '0 10px 15px -3px rgb(0 0 0 / 0.05)' }}
                formatter={(v: number) => [`${v}%`, 'NRR']}
              />
              <ReferenceLine y={100} stroke="#cbd5e1" strokeDasharray="3 3" label={{ position: 'right', value: '100% Base', fill: '#94a3b8', fontSize: 10, fontWeight: 'bold' }} />
              <Line 
                type="monotone" 
                dataKey="nrr" 
                stroke="#6366f1" 
                strokeWidth={3} 
                dot={{ r: 5, fill: '#6366f1', strokeWidth: 2, stroke: '#fff' }}
                activeDot={{ r: 7, strokeWidth: 0 }}
              />
            </LineChart>
          </ResponsiveContainer>
        )}
      </div>
    </div>
  );
};

export default NRRTrendChart;
